import dayjs from 'dayjs'
import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore'

import { firestore } from '../../../../../firebase/firebaseConfig'
import { Student } from '../../../../../types'
import { getProfileImage } from '../../../../../utilFunctions/profileImage'

export const filterStudent = (id: string, studentsList: Student[] | null) => {
  const student =
    studentsList && studentsList.find((student) => student.uid === id)
  const name = student?.name || ''
  const lastname = student?.lastname || ''
  return {
    name: `${name} ${lastname}`,
    image: getProfileImage(student?.image),
  }
}

export interface InactiveStudent extends Student {
  lastLog?: string | null
}

export const filterInactiveStudents = async (
  studentsList: Student[] | null,
): Promise<InactiveStudent[]> => {
  const inactiveStudents: InactiveStudent[] = []
  const threeMonthsAgo = dayjs().subtract(3, 'months')

  // Return empty array if studentsList is null or undefined
  if (!studentsList) return inactiveStudents

  for (const student of studentsList) {
    try {
      // Check if student has uid before trying to access logs
      if (!student?.uid) {
        console.warn('Student without uid found:', student)
        continue
      }

      const logsRef = collection(firestore, 'students', student.uid, 'logs')
      const q = query(logsRef, orderBy('date', 'desc'), limit(1))
      const logsSnap = await getDocs(q)

      if (!logsSnap.empty) {
        const lastLogData = logsSnap.docs[0].data()
        const lastLogDate = dayjs(lastLogData.date)

        if (lastLogDate.isBefore(threeMonthsAgo)) {
          inactiveStudents.push({
            ...student,
            lastLog: lastLogDate.format('YYYY-MM-DD'),
          })
        }
      } else {
        // Student has no logs, consider as inactive
        inactiveStudents.push({
          ...student,
          lastLog: null,
        })
      }
    } catch (error) {
      console.error(`Error getting logs for student ${student.uid}:`, error)
      // Optionally add student to inactive list even if there's an error
      inactiveStudents.push({
        ...student,
        lastLog: null,
      })
    }
  }

  return inactiveStudents
}
